export default __webpack_public_path__ + "static/media/black-text-measure-icon.765e9161.svg";